import { render, staticRenderFns } from "./TreatmentStatus.vue?vue&type=template&id=4eb0d4f1&"
import script from "./TreatmentStatus.vue?vue&type=script&lang=js&"
export * from "./TreatmentStatus.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentStatus.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports